/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AdminListingCheckStatus = {
    ListingCheckActive: 'active',
    ListingCheckEnded: 'ended',
    ListingCheckNotFound: 'not_found',
    ListingCheckUnresolved: 'unresolved',
    ListingCheckNotOurs: 'not_ours',
    ListingCheckError: 'error'
} as const;
export type AdminListingCheckStatus = typeof AdminListingCheckStatus[keyof typeof AdminListingCheckStatus];


export function instanceOfAdminListingCheckStatus(value: any): boolean {
    for (const key in AdminListingCheckStatus) {
        if (Object.prototype.hasOwnProperty.call(AdminListingCheckStatus, key)) {
            if (AdminListingCheckStatus[key as keyof typeof AdminListingCheckStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AdminListingCheckStatusFromJSON(json: any): AdminListingCheckStatus {
    return AdminListingCheckStatusFromJSONTyped(json, false);
}

export function AdminListingCheckStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminListingCheckStatus {
    return json as AdminListingCheckStatus;
}

export function AdminListingCheckStatusToJSON(value?: AdminListingCheckStatus | null): any {
    return value as any;
}

export function AdminListingCheckStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): AdminListingCheckStatus {
    return value as AdminListingCheckStatus;
}

